import { Vehicle } from '@typeRoots/common/vehicles';
export const emptyVehicle = {
  vin: '',
  year: '',
  make: '',
  model: '',
  radiusTravelled: '',
  comprehensive: 'Yes',
  collision: 'Yes',
  value: {
    amount: '0',
    currency: 'USD',
  },
  equipmentValue: {
    amount: '0',
    currency: 'USD',
  },
  classCode: '',
  bodyType: '',
  type: 'trailer',
  lossPayeeName: '',
  lossPayeeAddress: null,
  valuationType: '',
  active: true,
  company: {
    id: 1,
  },
} as Vehicle;
